/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        addOverlay();
      } );

      $( '.primary-menu-child-item__link' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
      } );

      const addOverlay = () => {
        $( '.navbar__overlay' ).toggleClass( 'is-open' );
      };

      $( '.primary-menu-item__link' ).on( 'toggleAfter', ( event ) => {
        if ( !window.matchMedia( '(max-width: 1270px)' ).matches ) {
          addOverlay();
          $( '#ll-body' ).toggleClass( 'is-open' );
        } else {
          /* ADA ensures focus is not lost when second menu opens on mobile */
          if ( window.easyToggleState.isActive( event.target ) ) {
            setTimeout( function() {
              $( `[data-toggle-trigger-off="${$( event.target ).attr( 'data-toggle-target' )}"]` ).trigger( 'focus' );
            }, 0 );
          }
        }
      } );

      /* ADA ensure secondary menu closes when you tab out and focus does not get lost */
      $( '.primary-menu-item__menu' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget === null ) return;
        const reltarget = $( event.relatedTarget );
        const currenttarget = $( event.currentTarget );
        const closeBtn = currenttarget.find( '.primary-menu-item__back' );

        if ( !reltarget.closest( '.primary-menu-item__menu' ).is( currenttarget ) && ( $( reltarget ).get( 0 ) !== closeBtn.get( 0 ) ) ) {
          closeBtn.trigger( 'click' );
        }
      } );

      /* ADA close primary nav when you tab out so focus does not get lost */
      $( '#primary-nav' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget === null ) return;
        if ( window.matchMedia( '(min-width: 1269px)' ) && $( '.navbar-toggle' ).hasClass( 'is-open' ) ) {
          const reltarget = $( event.relatedTarget );
          const currenttarget = $( event.currentTarget );

          if ( !reltarget.closest( '#primary-nav' ).is( currenttarget ) && ( $( reltarget ).get( 0 ) !== $( '.navbar-toggle' ).get( 0 ) ) ) {
            $( '.navbar-toggle' ).trigger( 'click' );
          }
        }
      } );

      const updateBannerHeight = () => {
        if ( $( '.nav__cta-banner' ).length > 0 ) {
          const ctaBannerHeight = $( '.nav__cta-banner' ).outerHeight();
          document.documentElement.style.setProperty( '--ctaBannerHeight', `${ctaBannerHeight}px` );
        }
      };

      function handleLargeChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-menu-item__link' ).attr( 'data-toggle-outside', true );

            $( '.navbar-toggle.is-open' ).trigger( 'click' );
            $( '.primary-menu-item__link.is-open' ).trigger( 'click' );
            $( '.primary-menu-child-item__link.is-open' ).trigger( 'click' );
            $( '.navbar__overlay.is-open' ).removeClass( 'is-open' );
            $( 'button[data-toggle-trigger-off]' ).removeAttr( 'data-toggle-trigger-off' );
          }
        } else {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-menu-item__link' ).removeAttr( 'data-toggle-outside' );
            $( 'button[data-trigger-off]' ).each( function() {
              const value = $( this ).data( 'trigger-off' );
              $( this ).attr( 'data-toggle-trigger-off', value );
            } );

            $( '.primary-menu-item__link.is-open' ).trigger( 'click' );
            $( '.primary-menu-child-item__link.is-open' ).trigger( 'click' );
            $( '.navbar__overlay.is-open' ).removeClass( 'is-open' );
            $( '#ll-body.is-open' ).removeClass( 'is-open' );
          }
        }
      }

      function handleMobileChange( event ) {
        if ( event.matches ) {
          updateBannerHeight();
        }
      }

      /* Run the handleLargeChange function when the screen sizes changes based on the largeSize const */
      const largeSize = window.matchMedia( '(min-width: 1269px)' );
      const mobileSize = window.matchMedia( '(max-width: 767px)' );
      handleLargeChange( largeSize );
      largeSize.addEventListener( 'change', handleLargeChange );
      mobileSize.addEventListener( 'change', handleMobileChange );
      handleMobileChange( mobileSize );

      /* END OF NAVIGATION JS */

      $( document ).on( 'submit', '.form-skin', function() {
        // Disable submit button
        $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      $( document ).on( 'click', '.js-init-video', function( e ) {
        e.preventDefault();
        const title = $( e.target ).data( 'title' );
        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
          },
          type: 'iframe',
          mainClass: 'mfp-fade',
          focus: '.mfp-close',
          closeBtnInside: true,
          autoFocusLast: true,
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              // get the current instance of the magnificPopup
              const currentMagnificPopup = $.magnificPopup.instance;

              // add title to the container aria label
              currentMagnificPopup.contentContainer.attr( 'role', 'dialog' );

              if ( title !== undefined ) {
                // get the current iframe element
                const currIframe = currentMagnificPopup.currTemplate.iframe.find( 'iframe' );
                // add title to the iframe and container
                currIframe.prop( 'title', title );
                currentMagnificPopup.contentContainer.attr( 'aria-label', `${title} player` );
              }

              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* allows File Upload input to update name when file is uploaded */
      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload .ll-file-details' );
          $( theInput ).text( filename );
        } );
      }

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      /* ADA - make sure image link is not in tab index since we are using title like to make whole card clickable */
      $( '.mec-event-image a' ).each( function() {
        $( this ).attr( 'tabindex', -1 );
      } );
      $( 'span.mec-nextprev-prev-button' ).attr( 'role', 'button' );
      $( 'span.mec-nextprev-prev-button' ).attr( 'tabindex', 0 );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
